import React, {useContext} from 'react';
import {useWatch} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormattedPrice from '@src/components/FormattedPrice/FormattedPrice';

export function ActualProductPriceField({rowIndex: index}: IListColumnProps) {
    const {
        control,
        fieldName,
        modelOptions = {}
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const products = useWatch({control, name: fieldName as 'products'});

    const product = products?.[index];
    if (!product || !product.custom_price && !product.product_id) {
        return <FormattedPrice amount="0"/>;
    }

    if (product.custom_price) {
        const price = product.custom_price_type === 'for-unit' ?
                product.custom_price :
                product.custom_price / product.quantity;

        return <FormattedPrice>{price}</FormattedPrice>;
    }

    const price = (modelOptions?.products as any)?.find(
            ({value}: { value: number }) => value === product.product_id
    )?.price;

    return <FormattedPrice>{price == null ? 0 : (price / 100)}</FormattedPrice>;
}
